import SwitchField, { type SwitchProps } from '../../../components/fields/SwitchField';

type SwitchFieldProps = SwitchProps;

const SwitchInputField = (props: SwitchFieldProps) => <SwitchField {...props} />;

export default SwitchInputField;
